'use client';
import { setNetworkTracking } from '@unifyapps/network/utils/tracking';
import { useEffect } from 'react';
import { onFCP, onLCP, onTTFB } from 'web-vitals';
import { useAnalytics } from '../../analytics/useAnalytics';
import type { WebVitalsMetric } from './types';

/**
 * Hook to track Web Vitals metrics (LCP, FCP, TTFB)
 *
 */
export function useInsights() {
  const { track, flush } = useAnalytics();

  useEffect(() => {
    setNetworkTracking(true, track);

    const trackVitals = (metric: WebVitalsMetric) => {
      const { name, value } = metric;

      if (name === 'TTFB' && metric.entries?.[0]?.entryType === 'navigation') {
        const loadTime = metric.entries[0].duration;
        track('PAGE_LOAD', {
          metrics: { duration: Math.round(loadTime) },
        });
      }

      const eventParams = {
        activityType: name,
        metrics: { duration: Math.round(value) },
      };

      track(eventParams.activityType, eventParams);
    };

    onFCP(trackVitals);
    onLCP(trackVitals);
    onTTFB(trackVitals);

    return () => {
      flush();
    };
  }, [flush, track]);
}
